import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./FusionModal.module.scss";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import polygonScanIcon from "../../../assets/icons/icon-polygon.png";

import IconFailed from "../../../assets/icons/store/icon_failed.png";
import IconCooldown from "../../../assets/icons/store/icon_cooldown.png";
import SuccessTickIcon from '../../../assets/icons/icon-success.svg';
import LoadingIcon from '../../../assets/icons/loading.svg';

const FusionModal = (props) => {
    const [t] = useTranslation();
    const {
        show,
        showSetter,
        completed,
        title,
        modalType,
        description,
        buttonText,
        buttonAction,
        txnHash,
        itemName,
        itemImage,
        itemAmount,
    } = props.content || {};

    const MODALTYPES = {
        PENDING: "pending",
        SUCCESS: "success",
        FAILED: "failed",
    };

    const closeModal = () => {
        showSetter(false);
    };

    const renderViewOnPolygonScan = (
        <a
            href={`${process.env.REACT_APP_POLYGON_BLOCK_EXPLORER_URL}tx/` + txnHash}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className={styles.view_on_polygonscan}>
                <img
                    src={polygonScanIcon}
                    className={styles.icon}
                    alt="polygon"
                />
                <div className={styles.text}>
                    {t("GIFT_VIEW_PROCESS_POLYSCAN_LINK_BTN")}
                </div>
            </div>
        </a>
    );

    const renderSubmitButton = (
        <Button
            variant="cdh-general-blue"
            className={styles.submit_btn}
            onClick={buttonAction}
        >
            {buttonText}
        </Button>
    );

    return (
        <>
            <Modal
                show={show}
                dialogClassName={styles.fusion_item_modal}
                contentClassName={styles.fusion_modal_body}
                onHide={closeModal}
                centered
            >
                <div className={styles.close_btn} onClick={closeModal}>
                    <FontAwesomeIcon icon={faTimes} />
                </div>
                <Modal.Header className={styles.fusion_item_modal_header}>
                    <div className={styles.modal_image_wrapper}>
                        {modalType === MODALTYPES["FAILED"] ? (
                            <div className={styles.failed_icon_wrapper}>
                                <img
                                    src={IconFailed}
                                    width="73px"
                                    height="68px"
                                    alt="store item"
                                />
                            </div>
                        ) : modalType === MODALTYPES["PENDING"] ? (
                            <div className={styles.failed_icon_wrapper}>
                                <img
                                    src={IconCooldown}
                                    width="73px"
                                    alt="cooldown"
                                />
                            </div>
                        ) : (
                            <div style={{ marginTop: "12px" }}>
                                <img
                                    src={completed ? SuccessTickIcon : LoadingIcon}
                                    width="73px"
                                    alt="cooldown"
                                />
                            </div>
                        )}
                    </div>
                </Modal.Header>
                <Modal.Body className={styles.fusion_item_modal_body}>
                    <div className={styles.modal_title}>{title}</div>
                    
                    {itemName && itemImage && itemAmount &&
                        <div className={styles.item_details_container}>
                            <div className={styles.horizontal_line}></div>
                            <div className={styles.item_details}>
                                <div className={styles.item_image_name}>
                                    <img src={itemImage} alt="item" />
                                    <span>{itemName}</span>
                                </div>
                                <div className={styles.item_count}>X{itemAmount}</div>
                            </div>
                            <div className={styles.horizontal_line}></div>
                        </div>
                    }

                    <div className={styles.modal_description}>
                        {description}
                    </div>
                </Modal.Body>
                <Modal.Footer className={styles.fusion_item_modal_footer}>
                    {buttonText && buttonAction && renderSubmitButton}
                    {txnHash && renderViewOnPolygonScan}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { FusionModal };
